/**
 * es6 polyfill，用来兼容ie
 * 可根据用到的es6特性按需引入
 */
import 'core-js/es6/symbol';
import 'core-js/es6/promise';

import '../ui-lib/lib/tiny/tiny-1.55.0-all';
import 'ui-router/angular-ui-router';
import 'base/pre/platformChecker.js';
import 'base/pre/browserChecker.js';
import 'base/pre/langTool.js';
import 'custom/js/language.js';
import 'custom/js/gaTools.js';
import "custom/js/gaTools/ha_f.js"
import 'authui/acctguard.js';

(function (url, callback) {
    var head = document.head || document.getElementsByTagName('head')[0];
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (typeof (callback) != "undefined") {
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {
            script.onload = function () {
                callback();
            };
        }
    };
    script.src = url;
    head.appendChild(script);
})("https://res-static1.huaweicloud.com/content/dam/cloudbu-site/archive/commons/apm/wise_trace.min.js");


// WEBPACK FOOTER //
// ./public/hws/vendor.js